import React from 'react';

import Header from '@components/Dashboard/CustomValues/Out/Header';
import Table from '@components/Dashboard/CustomValues/Out/Table';
import Billing from '@components/Dashboard/CustomValues/Out/Billing';
import NewCustomValueSidemodal from '@components/Dashboard/CustomValues/Out/NewCustomValueSidemodal';
import EditCustomValueSidemodal from '@components/Dashboard/CustomValues/Out/EditCustomValueSidemodal';

import { CUSTOM_VALUES_FILTER_CONFIG } from '@helpers/utils/filters/customValuesFilter';
import { useCustomValuesOut } from '@helpers/hooks/pages/dashboard/customValues/useCustomValuesOut';
import { useQuery } from '@helpers/hooks/useQuery';

import Filter from '@components/common/core/Utils/Filter';
import PageError from '@components/common/core/Utils/PageError';
import InstantHelp from '@components/common/core/Utils/InstantHelp';

import * as S from './styles';

const Wrapper: React.FC = () => {
  const query = useQuery();

  const fromRef = query.get('from');

  const {
    customValuesError,
    customValuesCategoriesError,
    customValueToEdit,
    selectedCustomValueChecked,
    isValidatingCustomValues,
    isValidatingCustomValuesCategories,
    mutateCustomValues,
    mutateCustomValuesCategories,
    customValuesCategories,
    isLoadingCustomValues,
    isLoadingCustomValuesCategories,
    openNewCustomValuesSideModal,
    verifyPreDefinedCustomValuesCategories,
    handleFilterData,
    filterData,
  } = useCustomValuesOut();

  const addNewData = React.useCallback(
    newData => {
      handleFilterData([newData]);
    },
    [handleFilterData],
  );

  const mutate = React.useCallback(async () => {
    const promises = [];

    if (customValuesError) promises.push(mutateCustomValues());

    if (customValuesCategoriesError) promises.push(mutateCustomValuesCategories());

    await Promise.all(promises);
  }, [
    customValuesError,
    customValuesCategoriesError,
    mutateCustomValuesCategories,
    mutateCustomValues,
  ]);

  React.useEffect(() => {
    if (customValuesCategories && !customValuesCategories.length) {
      verifyPreDefinedCustomValuesCategories();
    }
  }, [customValuesCategories, verifyPreDefinedCustomValuesCategories]);

  React.useEffect(() => {
    if (fromRef && customValuesCategories) {
      openNewCustomValuesSideModal();
    }
  }, [fromRef, customValuesCategories, openNewCustomValuesSideModal]);

  if (
    (customValuesError && !isValidatingCustomValues) ||
    (customValuesCategoriesError && !isValidatingCustomValuesCategories)
  ) {
    return <PageError mutate={mutate} />;
  }

  const isLoading =
    isLoadingCustomValues || isLoadingCustomValuesCategories || isValidatingCustomValues;

  const isInstantHelpComponentVisible = !isLoading && !selectedCustomValueChecked;

  return (
    <S.Content>
      <Header />

      {Boolean(!filterData.length) && (
        <S.FilterButton
          data={filterData}
          addNewData={addNewData}
          config={CUSTOM_VALUES_FILTER_CONFIG}
        />
      )}

      {Boolean(filterData.length) && (
        <Filter
          filterData={filterData}
          handleFilterData={handleFilterData}
          config={CUSTOM_VALUES_FILTER_CONFIG}
        />
      )}

      <Table />

      {isInstantHelpComponentVisible && (
        <InstantHelp
          name="custom_values_out"
          title="Valores Adicionais"
          articleLink="https://ajuda.profitfy.me/pt-br/articles/5901683-como-configurar-valores-adicionais"
        />
      )}

      {selectedCustomValueChecked && (
        <Billing selectedCustomValueChecked={selectedCustomValueChecked} />
      )}

      <NewCustomValueSidemodal />

      {customValueToEdit && <EditCustomValueSidemodal />}
    </S.Content>
  );
};

export default Wrapper;
